"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { createContext, useContext } from "use-context-selector";
import { useStore } from "zustand";
import { useItemActionQueryParam } from "@/hooks/query-param/use-action-query-param";
import { useStatusQueryParam } from "@/hooks/query-param/use-status-query-param";
import { createCollectionItemsPurchaseSelectionStore } from "./collection-items-purchase-selection-store";
import { createCollectionItemsSellSelectionStore } from "./collection-items-sell-selection-store";
const CollectionItemsPurchaseSelectionContext = createContext(createCollectionItemsPurchaseSelectionStore());
const CollectionItemsSellSelectionContext = createContext(createCollectionItemsSellSelectionStore());
const CollectionItemsSelectionContext = createContext({
  action: "buy",
  setAction: () => null
});
export function CollectionItemsSelectionProvider(t0) {
  const $ = _c(20);
  const {
    children
  } = t0;
  const [action, setAction] = useState("buy");
  const {
    statuses
  } = useStatusQueryParam();
  let t1;
  if ($[0] !== statuses) {
    t1 = statuses.includes("ownedByYou");
    $[0] = statuses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showingOwnedByYou = t1;
  const [purchaseSelectionStore] = useState(createCollectionItemsPurchaseSelectionStore);
  const [sellSelectionStore] = useState(createCollectionItemsSellSelectionStore);
  let t2;
  if ($[2] !== action) {
    t2 = {
      action,
      setAction
    };
    $[2] = action;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const value = t2;
  const {
    action: actionQueryParam
  } = useItemActionQueryParam();
  let t3;
  if ($[4] !== actionQueryParam) {
    t3 = () => {
      setAction(actionQueryParam);
    };
    $[4] = actionQueryParam;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] !== action || $[8] !== showingOwnedByYou) {
    t5 = () => {
      if (!showingOwnedByYou && action === "sell") {
        setAction("buy");
      }
      if (showingOwnedByYou && action === "buy") {
        setAction("sell");
      }
    };
    t6 = [showingOwnedByYou, action];
    $[7] = action;
    $[8] = showingOwnedByYou;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== children || $[12] !== sellSelectionStore) {
    t7 = <CollectionItemsSellSelectionContext.Provider value={sellSelectionStore}>{children}</CollectionItemsSellSelectionContext.Provider>;
    $[11] = children;
    $[12] = sellSelectionStore;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== purchaseSelectionStore || $[15] !== t7) {
    t8 = <CollectionItemsPurchaseSelectionContext.Provider value={purchaseSelectionStore}>{t7}</CollectionItemsPurchaseSelectionContext.Provider>;
    $[14] = purchaseSelectionStore;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8 || $[18] !== value) {
    t9 = <CollectionItemsSelectionContext.Provider value={value}>{t8}</CollectionItemsSelectionContext.Provider>;
    $[17] = t8;
    $[18] = value;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export const useCollectionItemsSelectionStore = () => {
  return useContext(CollectionItemsSelectionContext);
};
export const useCollectionItemsPurchaseSelectionStore = selector => {
  const storeContext = useContext(CollectionItemsPurchaseSelectionContext);
  return useStore(storeContext, selector);
};
export const useCollectionItemsSellSelectionStore = selector => {
  const storeContext = useContext(CollectionItemsSellSelectionContext);
  return useStore(storeContext, selector);
};